import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../../firebase/config';
import { setDoc, doc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  FormPageContainer,
  FormBox,
  FormTitle,
  Input,
  Button
} from '../common/Form.styles'; // <-- Import from new central file


const SignUp = () => {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { clientName: '', email: '', password: '' },
    validationSchema: Yup.object({
      clientName: Yup.string().required('Required'),
      email: Yup.string().email('Invalid email').required('Required'),
      password: Yup.string().min(6, 'Password must be 6+ characters').required('Required'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      const loadingToast = toast.loading("Creating your account...");
      try {
        const userCredential = await createUserWithEmailAndPassword(auth, values.email, values.password);
        const user = userCredential.user;
        
        await setDoc(doc(db, "users", user.uid), {
            clientName: values.clientName,
            email: values.email,
            role: 'client' 
        });

        toast.success("Account created! Logging you in...", { id: loadingToast });
        navigate('/client/dashboard');

      } catch (error) {
        const errorMessage = error.code === 'auth/email-already-in-use' 
            ? "This email is already in use." 
            : "Failed to create account.";
        toast.error(errorMessage, { id: loadingToast });
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <FormPageContainer>
      <FormBox>
        <form onSubmit={formik.handleSubmit}>
          <FormTitle>Create Account</FormTitle>
          <Input name="clientName" type="text" placeholder="Your Name" onChange={formik.handleChange} value={formik.values.clientName} />
          <Input name="email" type="email" placeholder="Email" onChange={formik.handleChange} value={formik.values.email} />
          <Input name="password" type="password" placeholder="Password" onChange={formik.handleChange} value={formik.values.password} />
          <Button type="submit" disabled={formik.isSubmitting}>Sign Up</Button>
        </form>
      </FormBox>
    </FormPageContainer>
  );
};

export default SignUp;